import { PAGE_SUBMIT_DELAY } from 'scripts/constants'
import { useContext } from 'preact/hooks'
import { FieldCommonProps } from '../type'
import FieldsContext from '../fieldsContext'

export default function useHandlersWithRequired<V = number | null>(
  setValue: (value: any) => any,
  required?: boolean,
  onFieldSubmit?: FieldCommonProps['onFieldSubmit'],
  onFieldChange?: FieldCommonProps['onFieldChange']
) {
  const { isMultipleFields } = useContext(FieldsContext)!
  const onClickHandler = () => {
    if (isMultipleFields) {
      onNext()
    } else {
      required && setTimeout(onNext, PAGE_SUBMIT_DELAY)
    }
  }

  const onNext = () => {
    setTimeout(
      () =>
        setValue((value: number) => {
          onFieldSubmit?.(value!)
          return value
        }),
      0
    )
  }

  const onChange = () => {
    setTimeout(
      () =>
        setValue((value: number) => {
          onFieldChange?.(value!)
          return value
        }),
      0
    )
  }

  return {
    onChange,
    onNext,
    onClickHandler,
  }
}
